import { render, staticRenderFns } from "./policy-tables-layout.vue?vue&type=template&id=c719c4c4"
import script from "./policy-tables-layout.vue?vue&type=script&lang=js"
export * from "./policy-tables-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports